import { fg } from '@atlaskit/platform-feature-flags';

import { PrimaryProductKeys } from '../constants/primary-product-keys';
import type { PrimaryProductKey } from '../constants/product-keys';

/**
 * Builds the AGG site ARI used as the `cloudIdARI` variable / `locations` value for
 * single-site search-page GraphQL queries.
 */
export const getCloudIdARI = (
	cloudId: string,
	primaryProduct: PrimaryProductKey | undefined,
): string =>
	primaryProduct === PrimaryProductKeys.Jira && fg('jira_site_ari_query_enabled')
		? `ari:cloud:jira::site/${cloudId}`
		: `ari:cloud:confluence::site/${cloudId}`;

/**
 * Builds the array of AGG site ARIs used as the `cloudIdARI` variable / `locations` value for
 * multi-site search-page GraphQL queries.
 */
export const getCloudIdARIs = (
	cloudId: string,
	primaryProduct: PrimaryProductKey | undefined,
): string[] => [getCloudIdARI(cloudId, primaryProduct)];
